import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from 'components/CircularProgress'

export class LoadingIcon extends React.Component {
  render = () => {
    return (<i className={'zmdi zmdi-replay zmdi-hc-spin-reverse zmdi-hc-' + this.props.size}/>)
  }
}

LoadingIcon.defaultProps = {
    size: '1x'
}

LoadingIcon.propTypes = {
  size: PropTypes.oneOf([ '1x', '2x', '3x', '4x', '5x' ])
}


export class LoadingView extends React.Component {

    render = () => {
      return (
        <div className='row'>
          <div className='col-12'>
            <CircularProgress scale={0.15}/>
            <div>{this.props.children}</div>
          </div>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./Linkgua/components/Loading/Loading.js